import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import AIVoiceSection from './components/AIVoiceSection';
import ExperienceSection from './components/ExperienceSection';
import ServicesSection from './components/ServicesSection';
import PortfolioSection from './components/PortfolioSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import SiteFooter from './components/SiteFooter';
import SEOJsonLd from './components/SEOJsonLd';

export default function Home() {
  return (
    <div className="bg-white text-gray-900 min-h-screen font-['Inter']">
      <SEOJsonLd />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <AIVoiceSection />
      <ExperienceSection />
      <ServicesSection />
      <PortfolioSection />
      <FAQSection />
      <ContactSection />
      <SiteFooter />
    </div>
  );
}
